import { useEffect } from 'react';

import { reportErrorToBugsnag } from '@air/utils-error';

import { getActiveUserSessionType } from '~/utils/auth/getActiveUserSessionType';

type IUseOnMissingUserSession = {
  onMissingSession: () => void;
  enabled: boolean;
};

export const useOnMissingUserSession = ({ onMissingSession, enabled }: IUseOnMissingUserSession) => {
  useEffect(() => {
    let isMounted = true;

    const checkIfLoggedIn = async () => {
      const activeSessionType = await getActiveUserSessionType();

      if (activeSessionType === 'none' && isMounted) {
        onMissingSession();
      }
    };

    if (enabled) {
      void checkIfLoggedIn().catch((error: unknown) => {
        reportErrorToBugsnag({
          error,
          context: 'Failed to check active user session',
        });
      });
    }

    return () => {
      isMounted = false;
    };
  }, [enabled, onMissingSession]);
};
